<template>
    <div class="absolute top-16 z-50 flex justify-center w-full">
        <div
            class="w-full sm:w-2/4 flex content-center shadow h-16 flash-notice error"
            v-if="errorNotice && errorNotice.length > 0"
        >
            <div class="help-notice-message flex-grow self-center">
                <i class="fad fa-exclamation mr-4"></i>{{ errorNotice }}
            </div>
            <div
                class="shrink w-16 text-sm cursor-pointer p-2 self-center"
                @click="close()"
            >
                <i class="ml-2 fal fa-times"></i>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    data: function () {
        return {};
    },
    mounted() {},
    methods: {
        close() {
            return this.$store.commit("ERROR", {});
        },
    },
    computed: {
        ...mapGetters(["error"]),
        errorNotice() {
            if ("message" in this.error) {
                return this.error.message;
            } else {
                return "";
            }
        },
    },
};
</script>

<style></style>
